import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support
serviceWorkerRegistration.register();

// Setup install prompt
serviceWorkerRegistration.setupInstallPrompt();

// Log PWA status
if (serviceWorkerRegistration.isInstalled()) {
  console.log('✅ VehicleBuddy is running as installed app');
} else {
  console.log('🌐 VehicleBuddy is running in browser');
}
